import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookingStatus } from '../../../helper/BookingStatus';
import { isBookingBlock } from './bookingDetailDisplayHelpers';
import {
  BOOKINGS_STATUS_PILL_COLORS,
  BookingsStatusPill,
  DEFAULT_BOOKINGS_STATUS_PILL_COLORS
} from './bookingsStatusBadgeStyles';

function isCancelledBlock(booking) {
  return (
    isBookingBlock(booking) &&
    parseInt(booking.status, 10) === BookingStatus.Cancelled
  );
}

function resolveBookingsStatusPillColors({ booking, statusLabel }) {
  if (booking && isBookingBlock(booking)) {
    if (isCancelledBlock(booking)) {
      return BOOKINGS_STATUS_PILL_COLORS.Cancelled;
    }
    return BOOKINGS_STATUS_PILL_COLORS.Block;
  }

  if (statusLabel && BOOKINGS_STATUS_PILL_COLORS[statusLabel]) {
    return BOOKINGS_STATUS_PILL_COLORS[statusLabel];
  }

  return DEFAULT_BOOKINGS_STATUS_PILL_COLORS;
}

const BookingsStatusBadge = ({ booking, statusLabel }) => {
  const { t } = useTranslation();

  if (booking && isBookingBlock(booking)) {
    if (isCancelledBlock(booking)) {
      const cancelledColors = BOOKINGS_STATUS_PILL_COLORS.Cancelled;
      return (
        <BookingsStatusPill
          $background={cancelledColors.background}
          $color={cancelledColors.color}
          $border={cancelledColors.border}>
          {t('Cancelled')}
        </BookingsStatusPill>
      );
    }

    const blockColors = BOOKINGS_STATUS_PILL_COLORS.Block;
    return (
      <BookingsStatusPill
        $background={blockColors.background}
        $color={blockColors.color}
        $border={blockColors.border}>
        {t('Block', { defaultValue: 'Block' })}
      </BookingsStatusPill>
    );
  }

  if (!statusLabel) return null;

  const colors = resolveBookingsStatusPillColors({ booking, statusLabel });

  return (
    <BookingsStatusPill
      $background={colors.background}
      $color={colors.color}
      $border={colors.border}>
      {t(statusLabel)}
    </BookingsStatusPill>
  );
};

export default BookingsStatusBadge;
